import {IconSelector} from './icon-selector';

/**
 * @extends {IconSelector}
 */
export class MaterialIconsSelector extends IconSelector {
  /**
   * @param {HTMLElement} elem
   * @param {Object} options
   */
  constructor(elem, options) {
    super(elem, options);
    this._materialIcons = null;
    this.iconsClass = 'material-icons';
    this.iconsClassPrefix = 'md';
    this.sizes = [
      {
        label: '75%',
        value: 'md-sm',
      },
      {
        label: '100%',
        value: '',
      },
      {
        label: '150%',
        value: 'md-lg',
      },
      {
        label: '200%',
        value: 'md-xl',
      },
    ];
    this.rotations = [
      {
        label: '0°',
        value: '',
      },
      {
        label: '90°',
        value: 'mi-rotate-90',
      },
      {
        label: '180°',
        value: 'mi-rotate-180',
      },
      {
        label: '270°',
        value: 'mi-rotate-270',
      },
      {
        label: 'auto',
        value: 'mi-spin',
      },
    ];

    // content from https://fonts.google.com/metadata/icons
    // just copy paste url content if this JSON file is not up to date
    this.metadataJsonFile = window.site_url +
      'static/manager/js/src/components/forms/icon-selector/material-icons-metadata.json';
  }
}
